/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest
 */
export interface FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest
     */
    Game: string;
    /**
     * https://developers.facebook.com/docs/games/monetize/in-app-purchases#verification
     * @type {string}
     * @memberof FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest
     */
    FbInstantPurchaseSignedData: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest(value: object): value is FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('FbInstantPurchaseSignedData' in value) || value['FbInstantPurchaseSignedData'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSON(json: any): FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'FbInstantPurchaseSignedData': json['FbInstantPurchaseSignedData'],
    };
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSON(json: any): FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSONTyped(value?: FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'FbInstantPurchaseSignedData': value['FbInstantPurchaseSignedData'],
    };
}

